var exports = {
  "v_": "DiscoveryNavbar.module__navbar___SFNDV2",
  "Bx": "DiscoveryNavbar.module__leftSection___SFNDV2",
  "jk": "DiscoveryNavbar.module__mobileCompanionButton___SFNDV2",
  "LY": "DiscoveryNavbar.module__leftSurface___SFNDV2",
  "Gv": "DiscoveryNavbar.module__backButton___SFNDV2",
  "dc": "DiscoveryNavbar.module__searchTitle___SFNDV2",
  "$L": "DiscoveryNavbar.module__categoryTabs___SFNDV2",
  "Wu": "DiscoveryNavbar.module__categoryTab___SFNDV2",
  "KB": "DiscoveryNavbar.module__categoryTabActive___SFNDV2" + " " + "DiscoveryNavbar.module__categoryTab___SFNDV2",
  "uk": "DiscoveryNavbar.module__searchArea___SFNDV2",
  "rm": "DiscoveryNavbar.module__searchForm___SFNDV2",
  "qc": "DiscoveryNavbar.module__searchIcon___SFNDV2",
  "Rt": "DiscoveryNavbar.module__searchInput___SFNDV2",
};

module.exports = exports;
